import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { ModelEntityType } from '@upright/common/model/input/types';
import { useIsTeam } from '@upright/ui/common/generic/hooks';
import { getInfoBoxModalId } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/modal-info-box-wrap';
import { useCarouselContext } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import { useSdgLensContext } from '@upright/ui/common/upright/core/impact-lenses/sdg/common/use-sdg-lens-context';
import { SdgDrilldownModal } from '@upright/ui/common/upright/model/output/scores/sdg-alignments/sdg-drilldown-modal';
import { sdgDrilldownModalMinScreenWidth } from '@upright/ui/common/upright/model/output/scores/sdg-alignments/sdg-drilldown-modal/constants';
import { useSdgUnitsMode } from '@upright/ui/common/upright/model/output/scores/sdg-alignments/use-sdg-unit-mode';
import { getVersionAndRelease } from '@upright/ui/untidy/redux/selectors';
import { useSelector } from 'react-redux';

export function SdgDrillDownBox() {
  // TODO: should not use the useIsTeam hook here, as the lens-impact-profile
  // should not depend on the global context. This should rather be passed to the
  // lens impact profile, which can pass info
  const isTeam = useIsTeam();
  const { release } = useSelector(getVersionAndRelease);
  const [unitsMode] = useSdgUnitsMode();
  const ctx = useSdgLensContext();
  const { layout } = useCarouselContext();
  if (!ctx) {
    return <></>;
  }
  const data = ctx.data;
  const alignments = data.sdgAlignments;
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!data || !alignments || layout.fullArea().width < sdgDrilldownModalMinScreenWidth) {
    return <></>;
  }

  const { resultId, entity, accessLevel } = data;
  const entityType = data.entity?.type || ModelEntityType.COMPANY;
  const sdgId = ctx.selectionState.sdg;
  const valence = ctx.selectionState.valence;
  const hasProductViewAccess = ctx.data.hasProductViewAccess !== undefined ? ctx.data.hasProductViewAccess : false;
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const drillDownData = entity && sdgId && valence && alignments && alignments[sdgId];
  const validEntityType =
    entityType === ModelEntityType.COMPANY ||
    entityType === ModelEntityType.GROUP ||
    entityType === ModelEntityType.PORTFOLIO;
  if (drillDownData && validEntityType && release) {
    return (
      <SdgDrilldownModal
        unitsMode={unitsMode}
        parentId={getInfoBoxModalId(ImpactLensType.SDGS)}
        entityType={entityType}
        valence={valence}
        resultId={resultId}
        entityId={entity.id}
        sdgId={sdgId}
        data={drillDownData}
        release={release}
        isOpen={true}
        onClose={() => {
          ctx.setSelectionState({});
        }}
        hasProductViewAccess={hasProductViewAccess}
        coverageClass={data.coverageClass}
        isTeamUser={isTeam}
        accessLevel={accessLevel}
      />
    );
  }
  return <></>;
}
